<script>
import { isValidPassword } from '@/utils/validation';
import { iButton, iTextInput, showToast } from '@inscribe/signal';
import PasswordInput from '@/V2/auth/PasswordInput';

export default {
  components: { iButton, iTextInput, PasswordInput },
  props: {
    passwordResetHash: {
      type: String,
      default: undefined,
    },
  },
  data() {
    return {
      loading: false,
      password: '',
      passwordConfirmation: '',
      displayHint: false,
      showPassword: false,
    };
  },
  computed: {
    isValidPassword() {
      return isValidPassword(this.password);
    },
    doPasswordsMatch() {
      return this.password === this.passwordConfirmation;
    },
  },
  methods: {
    resetPassword() {
      this.displayHint = false;
      if (this.isValidPassword && this.doPasswordsMatch) {
        const data = new FormData();
        data.append('password', this.password);
        data.append('password_confirmation', this.passwordConfirmation);
        this.loading = true;
        this.$store
          .dispatch('resetPassword', {
            passwordResetHash: this.passwordResetHash,
            data,
          })
          .then((response) => {
            this.loading = false;
            showToast({
              text: 'Password reset successfully. Please login',
            });
            this.$router.push({
              name: 'login',
            });
          })
          .catch((error) => {
            this.loading = false;
            showToast({
              title: 'There was a problem while resetting your password',
              text: error?.response?.data?.message || 'Please try again later',
              isError: true,
            });
          });
      } else {
        this.displayHint = true;
      }
    },
  },
};
</script>

<template>
  <div
    class="password-reset-screen auth-screen d-flex flex-column align-items-center justify-content-center i-gap-10"
  >
    <!-- title -->
    <div class="title d-flex flex-column align-items-center i-gap-1">
      <div class="i-text-heading-3 i-text-neutral-120">Reset Password</div>
      <div class="i-text-body-1 i-text-neutral-110">
        Enter and confirm your new password
      </div>
    </div>

    <!-- form -->
    <div class="form d-flex flex-column i-gap-10">
      <password-input
        :auto-focus="true"
        :value="password"
        :display-hint="displayHint"
        label="New password"
        @input="password = $event"
      />

      <!-- confirm password-->
      <i-text-input
        label="Confirm password"
        :value="passwordConfirmation"
        placeholder="One more time"
        name="confirm-password"
        :type="showPassword ? 'text' : 'password'"
        :has-error="displayHint && !doPasswordsMatch"
        :show-hint-text="displayHint && !doPasswordsMatch"
        hint-text="Your passwords don't match"
        :right-icon="showPassword ? 'small-edit-view-off' : 'small-edit-view'"
        @input="passwordConfirmation = $event"
        @on-input-enter="resetPassword()"
        @on-right-icon-click="showPassword = !showPassword"
      >
      </i-text-input>

      <!-- button -->
      <i-button
        text="Reset Password"
        type="primary"
        subtype="strong"
        size="lg"
        :loading="loading"
        @button-click="resetPassword"
      ></i-button>
    </div>
  </div>
</template>
